const PropTypes = require('prop-types');
// @vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter, Prompt } = require('react-router-dom');

// @commons
const { CommercialAdsCCValidated: CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { ContentBox } = require('commonsComponents/contentBox');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @components
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');
const BrokerMyInvestmentsProducts = require('components/broker/myInvestments/brokerMyInvestmentsProducts/brokerMyInvestmentsProducts');
const BrokerMyInvestmentsContracts = require('components/broker/myInvestments/brokerMyInvestmentsContracts/brokerMyInvestmentsContracts');
const { BrokerCustomProductLoader } = require('components/broker/brokerCustomProductLoader/brokerCustomProductLoader');
const {
    BrokerInvestmentSpecialist
} = require('components/broker/brokerInvestmentSpecialist/brokerInvestmentSpecialist');
const BrokerInformationAboutProduct = require('components/broker/brokerInformationAboutProduct/brokerInformationAboutProduct');
const { BrokerClientWarningModal } = require('components/broker/commons/brokerClientWarningModal/brokerClientWarningModal');
const { BrokerSearchWidget } = require('components/broker/brokerSearchWidget/brokerSearchWidget');
const BrokerRiskIndicator = require('components/broker/brokerRiskIndicator/brokerRiskIndicator');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { taggingEventHandled } = require('utilities/taggingEventHandled');

// @actions
const BrokerStocksByTypeActions = require('actions/brokerStocksByType');
const BrokerStocksByContractActions = require('actions/brokerWallets');
const BrokerOpenTraderActions = require('actions/brokerOpenTrader');
const BrokerOrdersAndMovementsActions = require('actions/brokerOrdersAndMovements');
const BrokerClientWarningModalAction = require('actions/brokerClientWarningModal');
const brokerContractState = require('actions/brokerContractState');
const BrokerSearchWidgetActions = require('actions/brokerSearchWidget');
const BrokerProductFiltersSearchActions = require('actions/brokerProductFiltersSearch');

// @utilities
const { scrollToTop } = require('commonsUtilities/scrollUtils');

const WebappRender = require('components/conditionalRender/webappRender')
// @constants
const {
    MYPROFILE_BROKER_EXPLORE_WARRANTS_URL,
    MYPROFILE_BROKER_URL,
    MYPROFILE_BROKER_ERROR_URL,
    TYPE_WARRANTS,
} = require('constants/index');
const { PROC_BROKER_WARRANTS_PG_NAME } = require('utilities/tagging');

class BrokerWarrantsView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            nextLocation: null,
            isBlockingRouteChange: false,
        };

        this.handleBuyClick = this.handleBuyClick.bind(this);
        this.buildWarrantsTabbedContent = this.buildWarrantsTabbedContent.bind(this);
        this.handleWarrantsBuySellClick = this.handleWarrantsBuySellClick.bind(this);
        this.breadcrumb = [
            {
                text: formatText('warrants-investments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('warrants-warrants'),
                url: ''
            }
        ];
    }

    componentDidMount() {
        const { immBrokerMyInvestments } = this.props;
        this.props.getStocksByType();
        this.props.getStocksContracts();
        this.props.checkPersonalInformationData();
        if (immBrokerMyInvestments.get('fetchSuccess')) {
            this.setPageInteraction();
        }
        scrollToTop();
    }

    componentDidUpdate(prevProps) {
        const { immBrokerMyInvestments } = this.props;
        const immBrokerMyInvestmentsPrev = prevProps.immBrokerMyInvestments;

        if (
            immBrokerMyInvestments.get('fetchSuccess') &&
            !immBrokerMyInvestmentsPrev.get('fetchSuccess')
        ) {
            this.setPageInteraction();
        }
    }

    setPageInteraction() {
        const { immBrokerMyInvestments } = this.props;
        const productStatus = immBrokerMyInvestments.getIn(['products', 'warrants', 'total']) > 0
            ? 'active'
            : 'empty';

        this.setState({
            setProductStatus: true,
        })
        taggingEventHandled(PROC_BROKER_WARRANTS_PG_NAME, 'productStatusActive', productStatus);
    }

    buildCallMeBackContent() {
        return <BrokerInvestmentSpecialist />;
    }

    buildProductInfoContent() {
        const { immBrokerMyInvestments } = this.props;
        const immStocksByType = immBrokerMyInvestments.get('products');
        const warrants = immStocksByType.get('warrants');
        const emptyStocks = !warrants || warrants.get('stocks').size === 0;

        return (
            <BrokerInformationAboutProduct
                productType={TYPE_WARRANTS}
                onBuyClick={() => this.handleBuyClick('comercialCard')}
                hasButton={!emptyStocks}
                pageName={PROC_BROKER_WARRANTS_PG_NAME}
            />
        );
    }

    getTabContent() {
        const {
            immAccounts,
            immBrokerContractState,
            immBrokerMyInvestments,
            immBrokerWallets,
            immMyWalletCharts,
            getContractState,
            getStocksByContract,
            postWalletAlias,
            setOrdersAndMovementsAccessFrom,
            setOrdersAndMovementsContract,
            onOpenTraderClick,
            immBrokerLandingLoader
        } = this.props;

        const activeTab = immBrokerLandingLoader.get('activeTab');
        const isFetchingStocksByContract = immBrokerWallets.get('isFetchingProducts');
        const immStocksByType = immBrokerMyInvestments.get('products');
        const immStocksByContract = immBrokerWallets.get('walletList');
        const immStocksContracts = immBrokerMyInvestments.get('contracts');
        const isFetchingStocksByType = immBrokerMyInvestments.get('isFetching');

        if (activeTab == 0) {
            return (<BrokerMyInvestmentsProducts
                immStocksByType={immStocksByType}
                isFetchingStocksByType={isFetchingStocksByType}
                setOrdersAndMovementsAccessFrom={setOrdersAndMovementsAccessFrom}
                displayAlternativeFunds={false}
                displayStocks={false}
                displayWarrants={true}
                displayETFs={false}
                displayFunds={false}
                displayCrypto={false}
                displayPlans={false}
                displayOthers={false}
                startExpanded={true}
                alternativeValueColumnTitle={true}
                displayFooter={false}
                onOpenTraderClick={onOpenTraderClick}
                onHandleBuyClick={this.handleWarrantsBuySellClick}
                resetSpecificProduct={this.props.resetSpecificProduct}
                pageName={PROC_BROKER_WARRANTS_PG_NAME}
            />);
        }

        return (<BrokerMyInvestmentsContracts
            getStocksByContract={getStocksByContract}
            immAccounts={immAccounts}
            immStocksByContract={immStocksByContract}
            immStocksContracts={immStocksContracts}
            immStocksByType={immStocksByType}
            immMyWalletCharts={immMyWalletCharts}
            isFetchingStocksByContract={isFetchingStocksByContract}
            postWalletAlias={postWalletAlias}
            setOrdersAndMovementsContract={setOrdersAndMovementsContract}
            onOpenTraderClick={onOpenTraderClick}
            displayStocks={true}
            displayPlans={false}
            displayFunds={false}
            displayCrypto={false}
            displayFooter={false}
            onHandleBuyClick={this.handleWarrantsBuySellClick}
            immBrokerContractState={immBrokerContractState}
            getContractState={getContractState}
            pageName={PROC_BROKER_WARRANTS_PG_NAME}
        />);
    }

    buildWarrantsTabbedContent() {
        const {
            immBrokerMyInvestments,
        } = this.props;

        const immStocksByType = immBrokerMyInvestments.get('products');
        const warrants = immStocksByType.get('warrants');
        const emptyStocks = !warrants || warrants.get('stocks').size === 0;
        const isFetchingStocksByType = immBrokerMyInvestments.get('isFetching');
        const title = formatText('warrants-myPositions');
        const tab = this.getTabContent();

        if (!isFetchingStocksByType && emptyStocks) {
            return undefined;
        }
        return (<ContentBox
            id="brokerWarrants"
            title={title}
            customClassName={"tabbed-content-box broker-my-investments"}
        >
            {tab}
        </ContentBox>);
    }

    handleBuyClick(component) {
        taggingEventHandled(PROC_BROKER_WARRANTS_PG_NAME, component === 'comercialCard' ? 'buyButtonComCard' : 'buyButton');
        this.props.resetSpecificProduct(TYPE_WARRANTS.toUpperCase());
        this.props.history.push(MYPROFILE_BROKER_EXPLORE_WARRANTS_URL);
    }

    handleWarrantsBuySellClick(nextLink) {
        const { immbrokerClientWarningModal, showClientWarningModal, history } = this.props;
        const clientPersonalInfoUpdated = immbrokerClientWarningModal.get('clientPersonalInfoUpdated');
        const isFetching = immbrokerClientWarningModal.get('isFetching');
        const isFetched = immbrokerClientWarningModal.get('isFetched');

        if (isFetched && !isFetching) {
            if (!clientPersonalInfoUpdated) {
                showClientWarningModal(history);
                this.setState({
                    nextLocation: nextLink,
                    isBlockingRouteChange: true
                });
            } else {
                history.push(nextLink);
            }
        } else if (!isFetched && !isFetching) {
            history.push(MYPROFILE_BROKER_ERROR_URL);
        }
        window.modalInstance = this;
    }

    render() {
        const { immBrokerMyInvestments } = this.props;
        const productInfoContent = this.buildProductInfoContent();
        const callMeBackContent = this.buildCallMeBackContent();
        const warrantsTabbedContent = this.buildWarrantsTabbedContent();
        let warrantsTabbedContentObject = null;
        let warrantsCTAsObject = null;
        const buySellBtnText = formatText('broker-buySellBtnText');
        const searchButtonText = formatText('brokerSearchWidget-brokerSearchWidget_searchWarrants');
        const isFetchingStocksByType = immBrokerMyInvestments.get('isFetching');
        let actionLinkButton = (
            <div className="broker-general-view__action-link-btn col-sm-4">
                <OKButton
                    modifier="primary"
                    onClick={this.handleBuyClick}
                >
                    {buySellBtnText}
                </OKButton>
            </div>
        );

        const searchButton = (
            <div className="broker-general-view__action-link-btn col-sm-8">
                <OKButton
                    modifier="secondary"
                    leftIcon="icon-s-buscar"
                    block={true}
                    onClick={() => {
                        taggingEventHandled(PROC_BROKER_WARRANTS_PG_NAME, 'searchButton')
                        this.props.handleShowSearchWidget()
                    }}
                >
                    {searchButtonText}
                </OKButton>
            </div>
        );

        if (!isFetchingStocksByType) {
            if (warrantsTabbedContent) {
                warrantsTabbedContentObject = (
                    <div className="row">
                        <div className="col-xs-12 col-md-8 broker-general-view__custom-product-loader">
                            <BrokerCustomProductLoader pageName={PROC_BROKER_WARRANTS_PG_NAME} />
                        </div>
                        <div className="col-xs-12 col-md-4 broker-general-view__general-action-link-group">
                            {searchButton}
                            {actionLinkButton}
                        </div>
                        <div className="col-md-12 grid-view--fix-cell-separation">
                            {warrantsTabbedContent}
                        </div>
                    </div>
                );
            } else {
                warrantsCTAsObject = (
                    <div className="row">
                        <div className="col-md-12 broker-general-view__landing-action-link-group">
                            {searchButton}
                            {actionLinkButton}
                        </div>
                    </div>
                );
            }
        }
        else {
            warrantsTabbedContentObject = <LoadingSection />
        }
        return (
            <React.Fragment>
                <Prompt message={() => false} when={this.state.isBlockingRouteChange} />
                <div>
                    <div className="broker-general-view__search-widget">
                        <BrokerSearchWidget product={TYPE_WARRANTS} />
                    </div>
                    <BrokerClientWarningModal
                        nextLocation={this.state.nextLocation}
                        routerHookCallback={() => {
                            this.setState({ isBlockingRouteChange: false });
                        }}
                    />
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="higher-small" section="broker" customClass="col-xs-12">
                                <BrokerTruncatedBreadcrumb
                                    titleKey="warrants-title"
                                    breadcrumbConfig={this.breadcrumb}
                                />
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid grid-view--content-position-positive">
                            <div className="broker-funds-view__broker-risk-indicator">
                                <BrokerRiskIndicator
                                    hasAlert={true}
                                    textContent="warrants-riskIndicatorWarrants_content"
                                    productType="Warrants"
                                />
                            </div>
                            {warrantsTabbedContentObject}
                            <div className="row">
                                <div className="col-xs-12 col-md-8">
                                    <div className="row">
                                        <div className={`col-md-12 ${warrantsTabbedContent ? 'grid-view--fix-cell-separation' : ''}`}>
                                            {productInfoContent}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-4">
                                    {warrantsCTAsObject}
                                    <div className="row">
                                        <div className="col-md-12 grid-view--fix-cell-separation">
                                            {callMeBackContent}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12 grid-view__sources">
                                    <FormattedText value="broker-infoWarrantsSource" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <WebappRender>
                        <div className="container-fluid grid-view__cross-selling">
                            <div className="row">
                                <CommercialAds path="broker/general" type="cross-selling" />
                            </div>
                        </div>
                    </WebappRender>
                </div>
            </React.Fragment>
        );
    }
}

BrokerWarrantsView.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immBrokerContractState: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immBrokerWallets: PropTypes.object.isRequired,
    getContractState: PropTypes.func.isRequired,
    getStocksByType: PropTypes.func.isRequired,
    getStocksContracts: PropTypes.func.isRequired,
    getStocksByContract: PropTypes.func.isRequired,
    postWalletAlias: PropTypes.func.isRequired,
    onOpenTraderClick: PropTypes.func.isRequired,
    setOrdersAndMovementsAccessFrom: PropTypes.func.isRequired,
    immbrokerClientWarningModal: PropTypes.object,
    showClientWarningModal: PropTypes.func,
    setOrdersAndMovementsContract: PropTypes.func.isRequired,
    checkPersonalInformationData: PropTypes.func,
    immMyWalletCharts: PropTypes.func.isRequired,
    immBrokerLandingLoader: PropTypes.object.isRequired,
    handleShowSearchWidget: PropTypes.func.isRequired,
    resetSpecificProduct: PropTypes.func,
};

module.exports.constructor = BrokerWarrantsView;
module.exports.BrokerWarrantsView = connect(
    state => ({
        immAccounts: state.accounts,
        immBrokerContractState: state.brokerContractState,
        immBrokerMyInvestments: state.brokerMyInvestments,
        immBrokerWallets: state.brokerWallets,
        immbrokerClientWarningModal: state.brokerClientWarningModal,
        immMyWalletCharts: state.myWalletCharts,
        immBrokerLandingLoader: state.brokerLandingLoader,
    }),
    {
        getContractState: brokerContractState.getContractState,
        getStocksByType: BrokerStocksByTypeActions.getStocksByType,
        getStocksContracts: BrokerStocksByContractActions.getWalletList,
        getStocksByContract: BrokerStocksByContractActions.getStocksByWallet,
        postWalletAlias: BrokerStocksByContractActions.postWalletAlias,
        onOpenTraderClick: BrokerOpenTraderActions.openLink,
        setOrdersAndMovementsAccessFrom: BrokerOrdersAndMovementsActions.setAccessFrom,
        setOrdersAndMovementsContract: BrokerOrdersAndMovementsActions.setContractNumber,
        showClientWarningModal: BrokerClientWarningModalAction.showClientWarningModal,
        checkPersonalInformationData: BrokerClientWarningModalAction.checkPersonalInformationData,
        handleShowSearchWidget: BrokerSearchWidgetActions.showSearchWidget,
        resetSpecificProduct: BrokerProductFiltersSearchActions.resetSpecificProduct,
    }
)(withRouter(BrokerWarrantsView));
